import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getARUniEntryRequestAllowedEduLevels,
  getARUniEntryRequestAllowedRecognitionStatuses,
} from "../../../../axios/api/services";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
} from "@duosoftbg/nacid-components";

const sliceName = "appData/arUniEntryRequestConstants";
const arUniEntryRequestConstantsSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState({ allowedRecognitionStatuses: [], allowedEduLevels: [] }),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(arUniEntryRequestConstantsThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(arUniEntryRequestConstantsThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(arUniEntryRequestConstantsThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const arUniEntryRequestConstantsThunk = createAsyncThunk(
  `${sliceName}/arUniEntryRequestConstantsThunk`,
  async () => {
    const eduLevelsResponse = await getARUniEntryRequestAllowedEduLevels()();
    const statusesReponse = await getARUniEntryRequestAllowedRecognitionStatuses()();
    return { data: { allowedRecognitionStatuses: statusesReponse, allowedEduLevels: eduLevelsResponse } };
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.arUniEntryRequestConstants);
    },
  },
);

export default arUniEntryRequestConstantsSlice.reducer;
